"use client";

import { ProductTileImageProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/ProductTileImageProps";
import { ProductImageWithSrcsetSizes } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductImageWithSrcsetSizes";
import { useSwatchInteraction } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/components/Swatch/SwatchInteractionContextProvider";
import { PRODUCT_GRID_IMAGE_BREAKPOINTS } from "@faire/deprecated-retailer-visitor-shared/views/search/const";

export const DynamicProductImage = ({
  data,
}: {
  data: ProductTileImageProps;
}) => {
  const {
    image,
    imageAltText,
    showVerticalImagery,
    onLoad,
    optionDetails,
    shouldPreloadImages,
  } = data;
  const { getActiveImage } = useSwatchInteraction();
  const activeImage = getActiveImage(image, optionDetails);
  return (
    <div
      key={activeImage.token}
      data-test-id={`carousel-image-${activeImage.token}`}
    >
      <ProductImageWithSrcsetSizes
        image={activeImage}
        alt={imageAltText ?? ""}
        sizes={PRODUCT_GRID_IMAGE_BREAKPOINTS}
        showVerticalImagery={showVerticalImagery}
        onLoad={onLoad}
        preload={shouldPreloadImages}
      />
    </div>
  );
};
